import { render } from "./CollaborationsMobile.vue?vue&type=template&id=29a287fa&scoped=true"
import script from "./CollaborationsMobile.vue?vue&type=script&lang=js"
export * from "./CollaborationsMobile.vue?vue&type=script&lang=js"

import "./CollaborationsMobile.vue?vue&type=style&index=0&id=29a287fa&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a287fa"]])

export default __exports__